module.exports = __webpack_public_path__ + "../resources/img/ic_module_pattern_portrait.7415feb2.svg";